import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

/**
 * Shared tokens for both theme variants. Vuetify components with `theme="dark"`
 * (e.g. PowerUpLayout app bar) read from the `dark` theme — if `dark` is omitted,
 * defaults apply and `secondary` becomes Material teal instead of PAX navy.
 */
const paxThemeColors = {
  // PAX / Power Asset Exchange — aligned to product UI (navy + orange accent)
  primary: "#EC3910",
  secondary: "#243D66",
  accent: "#EC3910",
  background: "#F5F6F8",
  surface: "#FFFFFF",
  "surface-variant": "#E8EDF3",
  "on-background": "#151F28",
  "on-surface": "#151F28",
  "on-primary": "#FFFFFF",
  "on-secondary": "#FFFFFF",
  /** Marketing site shell (PowerUpLayout footer). */
  marketingFooter: "#151F28",
  onMarketingFooter: "#FFFFFF",
} as const;

export const vuetifyConfig = {
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VNavigationDrawer: {
      style: `background-color: #f4f6f9;`,
    },
    VList: {
      style: `background-color: #f4f6f9;`,
    },
    VListItem: {
      style: `border-top: 1px solid rgba(36, 61, 102, 0.12);`,
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: { ...paxThemeColors },
      },
      dark: {
        dark: true,
        colors: { ...paxThemeColors },
      },
    },
  },
};
